import { FaWhatsapp, FaPhoneAlt } from "react-icons/fa"; // WhatsApp icon


export default function ContattiOrganizzativi() {
  return (
    <section className="my-20 px-4">
      <div className="max-w-5xl mx-auto bg-[#FFD500] rounded-full sm:px-20 px-10 sm:px-40 py-9 flex flex-row justify-between items-center text-center sm:text-left gap-4">
        <div className="flex items-center gap-4">
          <span className="text-black font-extrabold text-xl sm:text-3xl">
            SCRIVICI
          </span>
           
        </div>
        <a
          href="https://wa.me/393517408525"
          target="_blank"
          rel="noopener noreferrer"
          className="text-black text-xl sm:text-3xl font-normal underline hover:text-[#95BE32] transition"
        >
           <FaWhatsapp className="sm:w-20 sm:h-20 h-14 w-14 text-green-600" />
           
        </a>
      </div>
      <div className="max-w-5xl mx-auto bg-black mt-6 rounded-full sm:px-20 px-10 sm:px-40 py-9 flex flex-row justify-between items-center text-center sm:text-left gap-4">
        <div className="flex items-center gap-4">
          <span className="text-[#FFD500] black font-extrabold text-xl sm:text-3xl">
            CHIAMACI
          </span>
          <div className="flex text-[#FFD500]  hidden sm:block font-bold align-middle items-center text-xl sm:text-3xl">0722 330852</div>
           
        </div>

        <a
          href="tel:00390722330852"
          target="_blank"
          rel="noopener noreferrer"
          className="text-[#FFD500] text-xl sm:text-3xl font-normal hover:text-[#95BE32] transition"
        >
           <div className="flex align-middle items-center"><FaPhoneAlt className="ml-4 sm:w-20 sm:h-20 h-14 w-14" /></div>
           
        </a>
      </div>    </section>
  );
}
